export const ServiceConfig = {
  Ad: {
    placements: {
      'mobile-teacher-etc-top': { heightBp: 3429, isRounded: true, allowAnonymous: false },
      'mobile-parent-etc-top': { heightBp: 3429, isRounded: true, allowAnonymous: false },
      'mobile-payment-complete': { heightBp: 10000, isRounded: true, allowAnonymous: true },
    },
    measurementIntervalMs: 250,
    maxMeasurementGapMs: 500,
    reportIntervalMs: 5000,
    viewableMinContinuousMs: 1000,
    viewableMinRatioPermille: 500,
    apiRequestTimeoutMs: 5000,
  },
  Post: {
    maxTitleLength: 50,

    paragraphMaxCount: 15,

    imageMaxCount: 10,
    imageMaxLongSide: 2000,
    thumbnailImageMaxLongSide: 100, // 업로드시 화면에 표시하는 블루어 이미지 크기

    videoMaxCount: 1,

    attachmentMaxCount: 2,
    attachmentMaxSizeByte: 10 * 1024 * 1024,

    pmMaxStudentForEdit: 20, // 개인별 메시지에서 개별 수정이 가능한 최대 전체 인원

    maxTextParagraphLength: 2000,
    maxCommentLength: 300,
  },

  Common: {
    maxNameLength: 12,
    maxPhoneLength: 11,
    maxEmailLength: 45,
    minTeacherPasswordLen: 8,
    minUserPasswordLen: 8,
    maxPasswordLength: 12,
    maxClassNameLength: 20,
    maxSchoolNameLength: 20,
    maxAddressLength: 100,
    studentsInMultipleForm: 10, // 학생 여러명 등록의 개수
    maxNumberOfStudentsInAcademy: 500, // 재원생 + 외부생
    maxGeneralContentLength: 300, // 한줄메모
    maxTeacherIdLength: 20,
  },

  Attendance: {
    maxShortAcademyNameLength: 14,
    maxAttendanceCommentLength: 100,
    attPasswordLength: 12,
    maxLessonCount: 60,
    maxAttInfoMarkLength: 30,
  },

  Bill: {
    popbillAnotStartedAt: '2026-10-05T00:00:00+09:00',

    maxCorpNicknameLength: 5,
    presetNewItemCountPerDialog: 5,
    maxBillTitleLength: 50,
    maxBillMemoLength: 50,
    maxBillPresetTitleLength: 60,
    maxBillItemTitleLength: 65,
    minCbNumberLength: 10,
    maxCbNumberLength: 19,
    maxBillDueDay: 28, // 개인별 특정일 청구의 최대날짜

    maxRepSignatureImageSize: 300,
    signatureRequiredMinAmount: 50001,
    installmentAvailableMinAmount: 50000,
  },

  CounselLog: {
    maxContentLength: 500,
  },

  LessonReport: {
    maxTemplateTitleLength: 35,
    maxItemCount: 6,
    maxItemTitleLength: 10,
    selectOptionsMinLength: 2,
    selectOptionsMaxLength: 5,
    selectOptionsMaxTextLength: 5,
    maxScoreMinValue: 1,
    maxScoreMaxValue: 1000,
    maxShortTextItemLength: 10,
    maxLongTextItemLength: 500,
    maxSelectedGroupForWrite: 5,
  },

  Exam: {
    maxTemplateTitleLength: 35,
    maxGroupTitleLength: 50,
    maxCohortLength: 50,
    maxItemCount: 50,
    maxItemTitleLength: 50,
    maxScoreMinValue: 1,
    maxScoreMaxValue: 1000,
    maxTextItemLength: 1000,
    maxSelectedGroupForWrite: 5,
  },

  SimpleExam: {
    maxExamTitleLength: 30,
    maxMemoLength: 50,
  },

  Textbook: {
    maxTitleLength: 100,
    maxPublisherLength: 20,
    maxVariantLabelLength: 20,
    maxIsbnLength: 20,
    maxManagementCodeLength: 50,
    maxTagListLength: 100, // 콤마 포함
    maxSearchResultCount: 100,
  },

  TextbookXlsx: {
    version: 1,
    titleRow: 8,
    columns: [
      '교재명',
      '출판사',
      '판본',
      'ISBN',
      '학원내 관리코드',
      '기본 판매가격',
      '현재 재고',
      '태그1',
      '태그2',
      '태그3',
    ],
    maxFileSizeMB: 1,
    maxRowCount: 1000,
  },

  User: {
    maxProfileImageSize: 300,
  },

  Service: {
    ServiceName: '어나더클래스',
    GeneralDirectoryNumber: '0317018285',
    GeneralDirectoryMobilePhoneNumber: '01036128285',
    GeneralInquiryEmail: 'master@anotherclass.co.kr',
    GuideBaseUrl: 'https://guide.anotherclass.co.kr',
    AppStoreShortLink: 'bit.ly/anot',
    NoticeSenderEmail: 'noreply@anotherclass.co.kr',
    PwResetSenderEmail: 'noreply@anotherclass.co.kr',
    AdsSenderEmail: 'noreply@anotherclass.co.kr',
  },

  StudentXlsx: {
    version: 5,
    titleRow: 9,
    columns: [
      '이름',
      '학부모 연락처',
      '학생 연락처',
      '추가 연락처',
      '생년월일',
      '성별',
      '닉네임',
      '학교',
      '학년',
      '주소',
      '들어온 날',
      '한줄 메모',
    ],
    maxFileSizeMB: 0.5,
  },

  Chat: {
    maxContentLength: 300,
  },

  Homework: {
    maxAdditionalResourcesCount: 3,
    maxAdditionalResourceNameLength: 10,
    maxAdditionalResourceValueLength: 200,
    maxTitleLength: 50,
    maxDescriptionLength: 1000,

    maxTagListLength: 100, // 콤마 포함
    maxPresetCountPerRequest: 500,
    maxHomeworkPresetPerSource: 10000,

    Comment: {
      imageMaxCount: 5,
      attachmentMaxCount: 1,
    },
  },

  HomeworkXlsx: {
    version: 1,
    titleRow: 8,
    columns: [
      '제목',
      '내용',
      '참고자료1 제목',
      '참고자료1 내용',
      '참고자료2 제목',
      '참고자료2 내용',
      '참고자료3 제목',
      '참고자료3 내용',
      '태그',
    ],
    maxFileSizeMB: 1,
  },

  Message: {
    maxDailyChargeCount: 4,
  },
};
